export const apiLoadStart = () => {
    return{
        type: 'API_LOADER_START'
    }
}

export const apiLoadStop = () => {
    return{
        type: 'API_LOADER_STOP'
    }
}

//api data store
export const apiDataStore = (data) => { 
    return{
        type: 'API_DATA_STORE',
        payload: data
    }
}

//api data destroy
export const apiDataDestroy = () => { 
    return{
        type: 'API_DATA_DESTROY',
    }
} 

